<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <path
            fill="currentColor"
            d="M1.333 12V4h1.334v8H1.333Zm9.334 0-.95-.933 2.4-2.4H4V7.333h8.117l-2.384-2.4.934-.933 4 4-4 4Z"
        />
    </svg>
</template>

<script setup lang="ts">
type JumpIconProps = {
    ariaLabelledby?: string;
};
const props = defineProps<JumpIconProps>();
</script>
